<template>
  <b-overlay :show="loading">
    <b-card
      title="امار کلی کاربران"
    >
      <div style="position: relative;width: fit-content;margin:auto">
        <div
          class="pie-text text-center"
        >
          <h3
            class="font-weight-bolder"
          >
            {{ totalUser | price }}
          </h3>
          <span
            class="font-weight-bold"
          >مجموع</span>
        </div>
        <!-- echart -->
        <div>
          <app-echart-doughnut
            style="height: 300px;width:300px"
            :series="series"
          />
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>

import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut.vue'

export default {
  name: 'AllUsersReport',
  components: {
    AppEchartDoughnut,
  },
  data() {
    return {
      loading: false,
      totalUser: null,
      series: [
        {
          name: 'آمار کلی کاربران',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: '', name: 'کاربران رایگان' },
            { value: '', name: 'کاربران رژیم خریده اند' },
          ],
        },
      ],
    }
  },
  created() {
    this.setReports()
  },
  methods: {
    setReports() {
      this.loading = true
      this.$http.post(this.$api.report.totalUser, {}).then(response => {
        this.totalUser = response.data.TotalUser
        this.series[0].data[0].value = response.data.TotalUser - response.data.PaidUser
        this.series[0].data[1].value = response.data.PaidUser
      }).finally(() => this.loading = false)
    },
  },
}
</script>

<style lang="scss">
.card-body{
  position: relative;
  .pie-text{
    width: 105px;
    position:absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
  }
</style>
